<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">العملاء</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/clients">العملاء</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">عرض التفاصيل</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <div v-if="!mainLoading">
              <ClientsForm 
                v-if="checkAccess('users_update')"
                :key="'form-' + row?.id"
                cardTitle="عرض التفاصيل" 
                :dataRow="row" 
                @reloadClient="silentReload"
              />

              <ClientsView 
                v-else
                :key="'view-' + row?.id"
                :dataRow="row" 
                @reloadClient="silentReload"
              />
              <AdminNotesPanel
              v-show="!mainLoading"
              modelName="Users"
              :recordId="id"
            />
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import ClientsForm from './form.vue';
import ClientsView from "./view.vue";
import { checkAccess } from '@/helpers/tools';
import AdminNotesPanel from '../admin_notes/adminNotesPanel.vue';

export default {
  name: 'ClientsUpdate',
  components: {
    ClientsForm, ClientsView, AdminNotesPanel
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      row: null,
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.mainLoading = true;
      this.$http.get(`/api/admin/users/retrieve/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async silentReload(){
      const { data } = await this.$http.get(`/api/admin/users/retrieve/${this.id}`);
      this.row = data.row;
    }
  },
  created(){
    this.getRowData();
  }
}
</script>